var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row cardArea"},_vm._l((_vm.changedCardOptions),function(cardOption,index){return _c('div',{key:index,staticClass:"innerBox col-md-12",class:'col-xl-2'},[(cardOption.compVal || cardOption.baseVal)?_c('card-box',{ref:"cardBox",refInFor:true,attrs:{"options":cardOption}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }